import VideoTopicsIndex from './VideoTopicsIndex';
import VideoTopicsCreate from './VideoTopicsCreate';
import VideoTopicsSettings from './VideoTopicsSettings';
import VideoTopicsSingle from './VideoTopicsSingle';

export default function (app) {

    const settings = VideoTopicsSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    app.addMenu({
        key: settings.key,
        zone: settings.zone,
        label: settings.title,
        priority: 14,
        items: [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
            {
                label: "Re-Order",
                path: settings.path + "/reorder",
                caps: settings.createCaps
            },
        ],
    });

    VideoTopicsIndex(app, settings);

    VideoTopicsCreate(app, settings);

    VideoTopicsSingle(app, settings);

}